module.exports = __webpack_public_path__ + "img/straight-rail-diagonal-right-bottom-stone-path.3a698731.png";